import App from "../../services/App/App.js";
import AppCatalog from "../../services/App/AppCatalog.js";
import StopItemCatalog from "./StopItemCatalog.js";

export default {
  getItemInfo(item) {
    let infoList = [];

    // deleted item
    if (!item.DispatchIsActive) {
      infoList.push(AppCatalog.Info.DeletedItem);
    }

    // SKU
    infoList.push(StopItemCatalog.SKU.Label + ": " +
      App.Value.getValue("SKU", item, StopItemCatalog)
    );

    // DispatchSellPrice
    infoList.push(StopItemCatalog.DispatchSellPrice.Label + ": " +
      App.Value.getValue("DispatchSellPrice", item, StopItemCatalog)
    );

    return infoList;
  }
}